import { IntakeLabel } from '../entities/intake-label.interface';

export interface Lookup {
  code?: string;
  displayValue: string;
  htmlValue?: string;
  tips?: string;
  displayLabel?: IntakeLabel;
  thirdPartyValue?: string;
  helpText?: string;
  transformLookup?: string; //used to map the lookup transform label for dynamic lookup values
}

export interface Location {
  key?: string;
  displayName?: string;
  code?: string;
  default?: boolean;
  subLocation?: LocationList;
  isCanada?: boolean;
  isAlberta?: boolean;
}

export interface LocationList {
  [displayName: string]: Location;
}
